module.exports = __webpack_public_path__ + "img/avatar.285b01d9.jpg";